// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import shortid from "shortid";
import React from "react";
import ModalHeader from "../../header/subHeader";
import size from "lodash/size";
import { RouteComponentProps } from "react-router-dom";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import axios from "axios";
import { Spinner, SpinnerSize } from "office-ui-fabric-react/lib/Spinner";
import { bindActionCreators } from "redux";
import { constants } from "../../../../../common/constants";
import { generateKey } from "../../../../../common/crypto";
import pdfImage from "../../../../../assets/img/pdf.png";
import { IProject, IApplicationState,
    IAuthenticationState, AppError, ErrorCode,
    IConnection, IAzureFields } from "../../../../../models/applicationState";
import IConnectionActions, * as connectionActions from "../../../../../redux/actions/connectionActions";
import IApplicationActions, * as applicationActions from "../../../../../redux/actions/applicationActions";
import IProjectActions, * as projectActions from "../../../../../redux/actions/projectActions";
import IFilesUploadingAction, * as filesUploadingAction from "../../../../../redux/actions/filesUploadingAction";
import { getStorageItem, setStorageItem, removeStorageItem } from "../../../../../redux/middleware/localStorage";
import HeaderComponent from "../../header/header";
import { accessToken, fileUploadEndPoint,fileUploadEndPoint_PreBuilt } from "../../../../../common/api-config";
import ServiceHelper from "../../../../../services/serviceHelper"; 
import PrebuiltsubHeader from "../../header/prebuiltsubheader";

/**
 * Side bar that remains visible throughout app experience
 * Contains links to editor, settings, export, etc.
 * @member project - Project being edited
 * @param param0 - {
 *      project - IProject
 * }
 */

export interface IUploadFileProps extends RouteComponentProps, React.Props<PUploadFile> {
    project: IProject;
    recentProjects: IProject[];
    connections: IConnection;
    actions: IConnectionActions;
    loggedInUser: IAuthenticationState;
    appSecurityTokenAction: IApplicationActions;
    filesUploadingAction: IFilesUploadingAction;
    projectActions: IProjectActions;
}
export interface IIUploadFileState {
    /** Array of assets in project */
    fileNames: any[];
    fliesList: any[];
    formData: IProject;
    newFiles: any[];
    lengthOfFiles: any;
    spinnerString: string;
    testUpload: boolean;
    keyword: string;
    goNextPage: boolean;
    spinner: boolean;
    userId: string;
    nextFromtest: boolean;
    connection: IConnection;
}

function mapStateToProps(state: IApplicationState) {
    return {
        connections: state.connections,
        recentProjects: state.recentProjects,
        loggedInUser: state.loggedInUser,
        project: state.currentProject,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(connectionActions, dispatch),
        appSecurityTokenAction: bindActionCreators(applicationActions, dispatch),
        filesUploadingAction: bindActionCreators(filesUploadingAction, dispatch),
        projectActions: bindActionCreators(projectActions, dispatch),
    };
}
/**
 * Page for viewing/editing connections
 */
@connect(mapStateToProps, mapDispatchToProps)

class PUploadFile extends React.Component<IUploadFileProps, IIUploadFileState> {
    public state: IIUploadFileState = {
        fileNames: [],
        formData: {
            ...this.props.project,
        },
        goNextPage: false,
        newFiles: [],
        spinnerString: "",
        fliesList: [],
        userId: null,
        lengthOfFiles: 0,
        testUpload: false,
        keyword: "training",
        spinner: false,
        nextFromtest: false,
        connection: { id: null, name: null, providerType: "azureBlobStorage", providerOptions: {} },
    };
    constructor(props) {
        super(props);
        // this.setSasUrlConnection = this.setSasUrlConnection.bind(this);
    }
    public async componentDidMount() {
        
      

        const parts = this.props.match.path.split("/");
        const schemaParam = this.props.match.params;
        const signInUserSession = localStorage.getItem("signInUserSession");
        const user = signInUserSession && JSON.parse(signInUserSession);
        const userId = user && user.user.oid;
        this.setState({ userId });
        const lastSegment = parts.pop() || parts.pop();  // handle potential trailing slash
        if (lastSegment === "test") {
            this.setState({ keyword: "testing", testUpload: true, goNextPage: true});
        }
        if (schemaParam && schemaParam["projectId"]) {
                this.projectObject();
                const stringName = lastSegment === "test" ? "testFilesLengthFromTest" : "filesLengthFromModel";
                const filesLength = Number(localStorage.getItem(stringName));
                if (filesLength > 4) {
                    this.setState({ goNextPage: true });
                }
                // else if (lastSegment === "test" && filesLength > 1) {
                //     this.setState({ goNextPage: true });
                // }
                await this.setState({ lengthOfFiles: filesLength });
            } else {
                localStorage.removeItem("filesLengthFromModel");
                localStorage.removeItem("filesUploaded");
            }


    }

    public isPartialProject = (project: IProject): boolean => {
        return project && !(!!project.id) &&
            (
                !!project.name
                || !!project.description
                || (project.sourceConnection && Object.keys(project.sourceConnection).length > 0)
                || (project.tags && project.tags.length > 0)
            );
    }

    public setLocalStorage = (project: IProject) => {
        if (this.isPartialProject(project)) {
            setStorageItem(constants.projectFormTempKey, JSON.stringify(project));
        }
    }

    public projectObject = async () => {
        const { connection, nextFromtest } = this.state;
        connection.providerOptions["sas"] = IAzureFields.sasUrl;
        const projectName = this.props.match.params["projectName"];
        const parts = this.props.match.path.split("/");
        const lastSegment = parts.pop() || parts.pop();  // handle potential trailing slash
        const subFolderPath = lastSegment === "test" ? "testing" : "training";
        const projectId = this.props.match.params["projectId"] ? this.props.match.params["projectId"] : "";
        let projectCopy;
        if (lastSegment === "test") {
            const recentProject = await this.props.recentProjects.find((project) => project.id === projectId);
            projectCopy = Object.assign({}, recentProject);
            projectCopy.tags = projectCopy.tags;
            projectCopy.folderPath = `${projectName}-${this.state.userId}/testing`;
            projectCopy.fromModel = true;
            await this.props.projectActions.saveProject(projectCopy, false, false);
        } else {
            if (projectId) {
            const analysisResult = localStorage.getItem("trainResult");
            const analysis = analysisResult && analysisResult;
            console.log(analysis, "**analysis**");
            const formModel = projectId && analysis === "true"  ? true : false;
            console.log(formModel, "**formModel**");
            const recentProject = await this.props.recentProjects.find((project) => project.id === projectId);
            projectCopy = Object.assign({}, recentProject);
            projectCopy.tags = projectCopy.tags;
            projectCopy.folderPath = `${projectName}-${this.state.userId}/training`;
            projectCopy.fromModel = formModel;
            await this.props.projectActions.saveProject(projectCopy, false, false);
            } else {
                const typeParam = this.props.match.params["type"] ; //this.props.match.params["type"];
      /*
            projectCopy = {
                id: "",
                name: `${projectName}`,
                version: "",
                securityToken: "token",
                assets: {},
                tags: [],
                tableTags: [],
                fromModel: false,
                sourceConnection: connection,
                lastVisitedAssetId: "",
                apiUriBase: IAzureFields.endPoint,
                apiKey: IAzureFields.key,
                folderPath: `${projectName}-${this.state.userId}/${subFolderPath}`,
                
            };*/
            if(typeParam === 'od')
            {
               projectCopy = {
                   id: "",
                   name: `${projectName}`,
                   version: "",
                   securityToken: "token",
                   assets: {},
                   tags: [],
                   tableTags: [],
                   fromModel: false,
                   sourceConnection: connection,
                   lastVisitedAssetId: "",
                   apiUriBase: IAzureFields.endPoint,
                   apiKey: IAzureFields.key,
                   folderPath: `${projectName}-${this.state.userId}/${subFolderPath}`,
                   projType: typeParam,
                   cvProjId:"",
                   cvProjName:"",
                   isProjectSaved:false,
                   isProjectExported:false,

               };
            }
            else
            {
                projectCopy = {
               id: "",
               name: `${projectName}`,
               version: "",
               securityToken: "token",
               assets: {},
               tags: [],
               tableTags: [],
               fromModel: false,
               sourceConnection: connection,
               lastVisitedAssetId: "",
               apiUriBase: IAzureFields.endPoint,
               apiKey: IAzureFields.key,
               folderPath: `${projectName}-${this.state.userId}/${subFolderPath}`,
               projType: typeParam

           };
        }

            await this.props.projectActions.saveProject(projectCopy, false, false);
        }
        }
        // return projectCopy;
    }

    public setSasUrlConnection = async () => {
        // await this.props.appSecurityTokenAction.ensureSecurityToken(this.projectObject());
        // await this.props.projectActions.saveProject(this.setSasUrlConnection(), false, false);
    }

    public routeToPage = async () => {
        const { keyword } = this.state;
        await this.setState({ nextFromtest: true });
        await this.projectObject();
        const projectName = this.props.match.params["projectName"];
        const projectId = this.props.match.params["projectId"];
       
        const type = this.props.match.params["type"];
        const typeParam = this.props.project.projType ? this.props.project.projType:"na";

       

        const schemaParam = keyword === "testing" ? "na" : this.props.match.params["schema"];
    const urlPath = keyword === "testing" ? `${type}/test-files` : `${type}/edit`;
//this.props.history.push(`/OCRProjects/${projectName}/${projectId}/${urlPath}/${schemaParam}`);
if(type === 'ocr')
{
        this.props.history.push(`/OCRProjects/${projectName}/${projectId}/${urlPath}/${schemaParam}`);
}
else if(type === 'invo')
{
        
        this.props.history.push(`/Prebuilt/Projects/${projectName}/${projectId}/${urlPath}/${schemaParam}`);           
}
else if(type === 'od')
{    
    this.props.history.push(`/ODProjects/${projectName}/${projectId}/${urlPath}/${schemaParam}`); 
} 
else
{
    console.log("error -not able to fetch the project type");
}
    }

    public closeToast = (showUploadToast: boolean) => {
        const closeToast = showUploadToast ? 7000 : false;
        if (!showUploadToast) {
            toast.info(this.renderSpinner(),
            { className: "toast-inf-bg-color", toastId: 1, position: toast.POSITION.TOP_CENTER, hideProgressBar: false, autoClose: closeToast });
        }
        if (toast.isActive(1)) {
            toast.update(1,
            {  render: this.renderSpinner(), type: toast.TYPE.INFO, position: toast.POSITION.TOP_CENTER, hideProgressBar: false, autoClose: closeToast });
        }
    }

    public renderSpinner = () => {
        return (
            <div className="asset-loading">
            <div className="asset-loading-spinner">
            <Spinner label=" Your files are Uploading..." size={SpinnerSize.small} labelPosition="left" />
            </div>
        </div>
        )
    }

    public uploadFileToAzure = async () => {

       debugger;
        const { newFiles, keyword } = this.state;
        this.props.filesUploadingAction.clearFilesCount()
        const projectName = this.props.match.params["projectName"];
        const schemaParam = keyword === "testing" ? "na" : this.props.match.params["schema"];
       
        const projectId =this.props.match.params["projectId"] ?this.props.match.params["projectId"] :"";
        let typeParam ;       

        if(projectId)
        {
            typeParam = this.props.project.projType;//?this.props.project.projType:"na";
        }
        else
        {
            typeParam = this.props.match.params["type"]; // this.props.project.projType?this.props.project.projType:"na";
        }      
         if(!typeParam)
         {
            typeParam = this.props.match.params["type"];
         }
/*
         debugger;
         const modelObject = {
            project_name: projectName,
            user_id: this.state.userId,
            schema: schemaParam,
            project_type: "ocr",
        };
        this.props.projectActions.createNewModel(modelObject);
        await this.projectObject();
        const urlPath1 = keyword === "testing" ? `${typeParam}/test-files` : `${typeParam}/edit`;             
        this.props.history.push(`/Prebuilt/Projects/${projectName}/${this.props.match.params["projectId"] || this.props.project.id}/${urlPath1}/${schemaParam}`); 
       
      */
       
        if (size(newFiles) > 0) {
            this.setState({ spinnerString: "Uploading Files", spinner: true });
            if (!this.props.match.params["projectId"] || keyword === "testing") {
                if (keyword !== "testing") {
                    const modelObject = {
                        project_name: projectName,
                        user_id: this.state.userId,
                        schema: schemaParam,
                        project_type: "ocr",
                    };
                    this.props.projectActions.createNewModel(modelObject);
                    await this.projectObject();
                }
            }
            const tempArray = [];
            const tempUrls = [];
            let uploadFile = null;
            this.closeToast(false);
            const stringName = keyword === "testing" ? "testFilesLengthFromTest" : "filesLengthFromModel";
            localStorage.setItem(stringName, this.state.lengthOfFiles.toString());
            newFiles.forEach(async (file, index) => {
                const formData = new FormData();                              
              const name = file.filename;
              const lastDot = name.lastIndexOf(".");
        const fileName = name.substring(0, lastDot);
        const ext = name.substring(lastDot + 1);

              //if PDF 
              try {
                let result ;
              if(ext === "pdf")
              {
              formData.append("name", file.file);
            //  const URL = fileUploadEndPoint(projectName, file.filename, keyword, schemaParam, typeParam);
            const URL = fileUploadEndPoint_PreBuilt(projectName, file.filename, keyword, schemaParam, typeParam);
            
              result = await this.axiosPromise(URL, formData); 
            }
              else
              {
             
             
             //  formData.append("name", file);
               formData.append("name", file.file);
               const imgblob = new Blob([file.file], { type: 'image/jpeg'} );
               formData.append("content", imgblob);
               formData.append("src", window.URL.createObjectURL(file.file));
               const URL = fileUploadEndPoint_PreBuilt(projectName, file.filename, keyword, schemaParam, typeParam);
            
              // const URL = fileUploadEndPoint(projectName, file.filename, keyword, schemaParam,typeParam );
               result = await this.axiosPromiseimg(URL, formData, imgblob);
              }
              // else img

               // const URL = fileUploadEndPoint(projectName, file.filename, keyword, schemaParam, typeParam);
               
               // const result = await this.axiosPromise(URL, formData);
                if (result && result.data && result.data.status === "true") {
                    this.props.filesUploadingAction.setFilesCount();
                    if (index === newFiles.length - 1) {
                        uploadFile = true;
                        this.closeToast(true);
                    }
                    toast.success(`${result.data.file_name} Uploaded Successfully`, { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
                } else if (result && result.data && result.data.status === "false") {
                    const { lengthOfFiles } = this.state;
                    const newFiles = [...this.state.newFiles];
                    const index = newFiles.indexOf(file);
                    let arrayLength;
                    if (index > -1) {
                        newFiles.splice(index, 1);
                        arrayLength = lengthOfFiles - 1;
                    }
                    if (index === newFiles.length - 1) {
                        this.closeToast(true);
                    }
                    const stringName = keyword === "test" ? "testFilesLengthFromTest" : "filesLengthFromModel";
                    localStorage.setItem(stringName, arrayLength.toString());
                    toast.warn(`${result.data.file_name} Failed`, { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
                } else {
                    this.closeToast(true);
                }
                } catch(err) {
                    ServiceHelper.handleServiceError(err);
                };
            });
            localStorage.setItem("project_name", projectName);
         
             const urlPath = keyword === "testing" ? `${typeParam}/test-files` : `${typeParam}/edit`;

             debugger;
             if(typeParam === 'ocr')
             {
                setTimeout(() => {                    
                    this.props.history.push(`/OCRProjects/${projectName}/${this.props.match.params["projectId"] || this.props.project.id}/${urlPath}/${schemaParam}`);
                   
                  }, 500);                   
             }
             else if(typeParam === 'invo')
{
        
    setTimeout(() => {                    
        this.props.history.push(`/Prebuilt/Projects/${projectName}/${this.props.match.params["projectId"] || this.props.project.id}/${urlPath}/${schemaParam}`); 
       
      }, 500); 
                  
}
         else if(typeParam === 'od')
            {  
             setTimeout(() => {                  
                    this.props.history.push(`/ODProjects/${projectName}/${this.props.match.params["projectId"] || this.props.project.id}/${urlPath}/${schemaParam}`);
                   
               }, 500);                
             } 
            // else
            // {
            //     console.log("error -not able to fetch the project type");
             //}
             //

           
         //   setTimeout(() =>             
             // this.props.history.push(`/projectsFR/${projectName}/${this.props.match.params["projectId"] || this.props.project.id}/${urlPath}/${schemaParam}`);
             
           // }, 500);

        } else {
            if (this.state.goNextPage) {
                this.routeToPage()
            } else {
            toast.warn("Please select minimum one file.", { position: toast.POSITION.TOP_CENTER });
            }
        }
    }

    public axiosPromiseimg = (URL: string, formData, imgblob) => {
        const headers = accessToken();
 
       //  return axios(URL, { method: "POST", data: formData, headers });
         return axios(URL, { method: "POST",data:imgblob , headers });
     }
 
    public axiosPromise = (URL: string, formData) => {
       const headers = accessToken();
       /* const signInUserSession = localStorage.getItem("signInUserSession");
        const user = signInUserSession && JSON.parse(signInUserSession);
        const accessToken = user && user.access_token;
        //const headers = {'Content-Type': `multipart/form-data; boundary=${formData._boundary}`, 
         //"Authorization": `Bearer ${accessToken}`, "cache-control": "no-cache" };
      
      */   
      //  const headers = {'Content-Type': 'multipart/form-data', "Authorization": `Bearer ${accessToken}`, "cache-control": "no-cache" };
      
       //  const headers = {"Authorization": `Bearer ${accessToken}`, "cache-control": "no-cache" };
      
        //console.log(JSON.stringify(formData));
      //  debugger;

   /*  return   fetch(URL, {
            method: 'POST',
            headers: {         
          'Authorization': `Bearer ${accessToken}`
            },
            body: formData
          }).then((response) => {
              debugger;
              console.error("response:"+response);
            return response.json();
          })
           .catch((error) => {
            console.error(error);
            return error.json();
          });*/

        //  return result;
        return axios(URL, { method: "POST", data: formData,headers });
/*
       return axios({
        method: 'post',
        url: URL,
        data: formData ,
       // headers: headers
        });
*/
    }

    public getFileNameWithExt = async (file) => {
        let { fileNames, newFiles, lengthOfFiles, fliesList } = this.state;
        const name = file.name;
        const lastDot = name.lastIndexOf(".");
        const fileName = name.substring(0, lastDot);
        const ext = name.substring(lastDot + 1);
//^[a-zA-Z]+[a-zA-Z0-9-_]*

//
//const regexQuery =  "^([a-zA-Z]+[a-zA-Z0-9-_]*)$"; 
//const regexQuery = "^([a-zA-Z]+[a-zA-Z0-9-_]*\.[A-Za-z]{3,4})$";
const regexQuery = "^([a-zA-Z0-9-_]{2,50}\.[A-Za-z]{3,4})$";
const url = new RegExp(regexQuery, "i");
console.log("filename==>"+name);
if (url.test(name)) {

//
         
        if (fileNames.indexOf(name) === -1) {
            const src = ext === "pdf" ? pdfImage : window.URL.createObjectURL(file);
            const fileData = {};
            fileData["file"] = file;
            fileData["src"] = src;
            fileData["filename"] = name;
            fileNames.push(file["name"]);
            newFiles.push(fileData);
        } else {
            fileNames = fileNames;
            newFiles = newFiles;
            toast.success(`${file["name"]} file is exists`, { position: toast.POSITION.TOP_CENTER });
        }
    }
    else
    {
        fileNames = fileNames;
        newFiles = newFiles;
        toast.warn(`${file["name"]} file is invalid`, { position: toast.POSITION.TOP_CENTER });
    }
        const arrayLength = newFiles.length + lengthOfFiles;
        await this.setState({
            fileNames,
            lengthOfFiles: arrayLength,
            newFiles,
        });
    }

    public onChangeHandler = (event) => {
        event.persist();
        if (event.target.files.length > 0) {
            const arrFiles = Array.from(event.target.files);
            arrFiles.forEach((file) => {
                this.getFileNameWithExt(file);
            });
        }
    }

    public render() {
        const { fliesList, newFiles, lengthOfFiles, spinnerString, testUpload } = this.state;
        if (newFiles.length > 0) {
            const element = document.getElementById("myDocs");
            const element1 = document.getElementById("before-select");
            if (element && element1) {
                element.classList.add("loaded");
                element1.classList.add("after-select");
                element1.classList.remove("d-block");
            }
        }
      //  debugger;
        const type = this.props.match.params["type"];
        //const type = this.props.match.params["type"];
        const minFileLength = testUpload ? 1 : 5;
        return (
            <>
                <HeaderComponent
                    history={this.props.history}
                    match={this.props.match}
                    location={this.props.location} />

               
                <PrebuiltsubHeader
                    history={this.props.history}
                    match={this.props.match}
                    actions={this.props.projectActions}
                    location={this.props.location}
                    project={this.props.project} />
                   
                {this.state.spinner ?
                    <div>
                        <Spinner
                            size={SpinnerSize.large}
                            label={`${spinnerString}`}
                            ariaLive="polite"
                            className="mt-5"
                            labelPosition="top"
                        />
                    </div> : (
                        <div className="container-fluid animated fadeIn">
                            {/* <div className="row">
                        <div className="col-md-12">
                            <h4>Upload Files</h4>
                        </div>
                    </div> */}
                            <div className="row mt-3">

                                <div className="col-lg-2 ">

                                </div>
                                <div className="col-lg-4 ">
                                    Total number of Files uploaded so far: {lengthOfFiles}
                                </div>
                                <div className="col-lg-4 text-right ">
                                    Minimum Files Required: {minFileLength}
                                </div>

                            </div>

                            <div className="row">

                                <div className="col-lg-2 ">

                                </div>

                                <div className="col-lg-8 ">
                                    <div id="myDocs" className="card wrap-upload shadow to-b-load">
                                        <div className="upload-block">
                                            {newFiles && newFiles.length > 0
                                                && newFiles.map((file, index) => {
                                                    return (
                                                        <div key={index} className="doc">
                                                            <img src={file.src} className="img-fluid" />
                                                            <div className="ann-info">
                                                                <a role="button" onClick={() => this.deleteFile(file)} className="cursor-pointer  del">
                                                                    <i className="fa fa-trash" aria-hidden="true"></i>
                                                                </a>
                                                                <div className="count">
                                                                    {index + 1}
                                                                </div>
                                                            </div>
                                                            <div className="doc-info">
                                                                <span className="name">{file.filename}</span>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            <input type="file" accept="application/pdf, image/jpeg, image/png, image/tiff"
                                                onChange={this.onChangeHandler}
                                                multiple
                                                id="before-select"
                                                className="upload-docs d-block" />
                                            <label htmlFor="upload">Drop files here or click to upload</label>
                                        </div>
                                        <div className="doc last-doc">
                                            <input type="file" accept="application/pdf, image/jpeg, image/png, image/tiff"
                                                multiple
                                                onChange={this.onChangeHandler} className="upload-docs d-block" />
                                            <div className="more-files">
                                                <i className="fa fa-upload" aria-hidden="true"></i><br />
                                                Click to upload more file</div>
                                        </div>
                                    </div>

                                </div>
                                <div className="col-lg-2 ">
                                </div>
                            </div>
                            <div className="row mt-2">

                                <div className="col-lg-2 ">

                                </div>

                                <div className="col-lg-8 text-center">
                                    <button onClick={() => this.uploadFileToAzure()}
                                        type="button" className="btn mr-2" >
                                        {/* <i className="fa fa-upload" aria-hidden="true"></i>  */}
                                        Next</button>
                                    {/* {this.state.goNextPage &&
                                        <button onClick={() => this.routeToPage()}
                                            type="button" className="btn" >
                                            Next</button>} */}
                                </div>
                            </div>
                        </div>
                    )}
            </>
        );
    }

    /**
     * private delete file
     */
    private deleteFile = (file) => {
        const { lengthOfFiles } = this.state;
        const newFiles = [...this.state.newFiles];
        const index = newFiles.indexOf(file);
        let arrayLength;
        if (index > -1) {
            newFiles.splice(index, 1);
            arrayLength = lengthOfFiles - 1;
        }
        this.setState({ newFiles, lengthOfFiles: arrayLength });
    }
}

export default PUploadFile;
